import { render, staticRenderFns } from "./oscillogram.vue?vue&type=template&id=2304f32d&scoped=true&"
import script from "./oscillogram.vue?vue&type=script&lang=js&"
export * from "./oscillogram.vue?vue&type=script&lang=js&"
import style0 from "./oscillogram.vue?vue&type=style&index=0&id=2304f32d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304f32d",
  null
  
)

export default component.exports